import { render } from "./storyBlock.vue?vue&type=template&id=42ec1151&scoped=true"
import script from "./storyBlock.vue?vue&type=script&lang=js"
export * from "./storyBlock.vue?vue&type=script&lang=js"

import "./storyBlock.vue?vue&type=style&index=0&id=42ec1151&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42ec1151"

export default script